module.exports = __webpack_public_path__ + "img/LogoBosonWhite.adbfb96f.png";